import { PlatformHeader } from '@quickplay/platform-authorizer';
import { PlaybackMode } from '../../../fl-content-authorization';
import { AdType, BlackoutAction, Promo, TrackKind } from '@quickplay/player-interface';

export interface PlaybackAuthorizationResponse {
  header: PlatformHeader;
  data: PlaybackAuthorizationData;
}

/**
 * License token item that could be added with license requests
 */
export interface LicenseToken {
  type: string;
  name: string;
  value: string;
}

/**
 *  Licenser provider information
 */
export interface LicenseProvider {
  provider: string;
  version: string;
}

/**
 * sprite image information for keyframe scrubbing.
 */
export interface KeyframeMetadata {
  name?: string;
  ia: string[];
  frequency: number;
  width: number;
  height: number;
  rows: number;
  columns: number;
}

export interface PlaybackAuthorizationData {
  contentId: string;
  contentUrl: string;
  licenseUrl: string;
  mediaFormat: string;
  drm: string;
  skd?: string;
  fpCertificateUrl?: string;
  licenseProvider?: LicenseProvider;
  licenseToken?: LicenseToken;
  subtitle?: SubtitleSidecarMetadata[];
  cuepoints?: Cuepoint[];
  heartbeatFlag?: boolean;
  heartbeatToken?: string;
  heartbeatFreq?: number;
  blackoutUrl?: string;
  blackoutAction?: BlackoutAction;
  ssaiEnabled?: boolean;
  liveStartTime?: string;
  liveEndTime?: string;
  livePlaybackMode?: PlaybackMode;
  liveEventType?: string;
  preSlateContentUrl?: string;
  postSlateContentUrl?: string;
  preSlateStartTime?: string;
  preSlateEndTime?: string;
  postSlateStartTime?: string;
  postSlateEndTime?: string;
  licenseRefreshToken?: string;
  keyframe?: KeyframeMetadata;
  streamId?: string;
  bumperSegment?: Promo[];
  adType?: AdTechnology;
  csaiAdCuePointVmap?: string;
  csaiAdCuePointVast?: CsaiAdCuePointVast[];
  live360Enabled?: boolean;
  live360StartTime?: string;
  live360EndTime?: string;
  live360ContentId?: string;
  assetKey?: string;
  cmsID?: string;
  apiKey?: string;
  pgmId?: string;
  pgmStartTime?: string;
  pgmEndTime?: string;
  pgmBlackout?: boolean;
  custom?: { [key: string]: any };
  ssaiAdProvider?: string;
  csaiAdProvider?: string;
}

/**
 * Subtitle entry as sent by the backend; mapped to `Subtitle` before reaching clients.
 */
export interface SubtitleSidecarMetadata {
  ty?: string;
  lang?: string;
  su?: string;
}

export interface Subtitle {
  type?: TrackKind;
  languageCode?: string;
  url?: string;
}

export interface Cuepoint {
  start: number;
  end: number;
  type: string;
  url: string;
}

export interface CsaiAdCuePointVast {
  start: number;
  end: number;
  type: AdType;
  provider: string;
  url: string;
}

export enum AdTechnology {
  CSAI = 'csai',
  SSAI = 'ssai',
}
